module.exports = __webpack_public_path__ + "static/media/confused_lady.018e7fef.png";